import { MdAirplaneTicket } from "react-icons/md";
import GroupTripService from "services/admin/GroupTripService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const GroupTripsCount = ({ month }) => {
  const q = useDashboardQuery(["group-trips-count", month], async () => (await GroupTripService.count({ month })).data);

  return (
    <KpiCard
      icon={MdAirplaneTicket}
      accent="sky"
      label="Поездки"
      hint="Групповые поездки за выбранный период"
      to="/admin/group-trips"
      value={formatNumber(q.data)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default GroupTripsCount;
